/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Booking/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import InPerson from './InPerson/index'
import No from './No/index'
import NoBooking from './NoBooking/index'
import React from 'react'
import Virtual from './Virtual/index'



/** @type {import('Simple/types.js').View} */
export default function Booking({
  children,
  viewPath = "/App/Widget/Content/Questions/Complete/Booking"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let widgetHasBookingValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'hasBooking',
})
let selectedAnswersLocationLocationvisittypeValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers.location.locationVisitType',
})
let selectedAnswersInsuranceValueValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers.insurance.value',
})
let widgetSettingsDefaultinsuranceValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'settings.defaultInsurance',
})
let aggregateData = fromHelpers.getView(widgetHasBookingValueData, selectedAnswersLocationLocationvisittypeValueData, selectedAnswersInsuranceValueValueData, widgetSettingsDefaultinsuranceValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NoBooking'}>
<NoBooking
  viewPath={`${viewPath}/NoBooking`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Virtual'}>
<Virtual
  viewPath={`${viewPath}/Virtual`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InPerson'}>
<InPerson
  viewPath={`${viewPath}/InPerson`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}